import { render } from "./ProviderEditData.vue?vue&type=template&id=6cb5975d"
import script from "./ProviderEditData.vue?vue&type=script&lang=js"
export * from "./ProviderEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__